"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Beverage = void 0;
var React = require("react");
var state_1 = require("../compare/state");
var Grid_1 = require("@material-ui/core/Grid");
var Beverage = function () {
    var state = (0, state_1.useStateValue)().state;
    var products = state.products;
    var foodPairings = {
        "Aperitiff/avec": "aperitif",
        "Dessert, kake, frukt": "dessert",
        "Fisk": "fisk",
        "Grønnsaker": "gronnsak",
        "Lam og sau": "lam",
        "Lyst kjøtt": "lystkjott",
        "Ost": "ost",
        "Skalldyr": "skalldyr",
        "Småvilt og fugl": "smaavilt",
        "Storfe": "storfe",
        "Storvilt": "vilt",
        "Svinekjøtt": "svinekjott"
    };
    var counter = 0;
    function getFoodPairings(foodPairing) {
        if (foodPairing) {
            return React.createElement(Grid_1.default, { item: true, xs: 12, sm: 3 },
                React.createElement("img", { src: "/images/Icons/beverage/foodparing/".concat(foodPairings[foodPairing], ".png"), title: foodPairing, alt: foodPairing, className: "small-icon" }));
        }
        return null;
    }
    function getTaste(taste, name) {
        var maxTaste = 3;
        if (taste > 0 && counter < maxTaste) {
            counter++;
            return (React.createElement(Grid_1.default, { item: true, xs: 12, sm: 3, "data-testid": "taste-grid" },
                React.createElement("div", null, name),
                React.createElement("img", { src: "/images/Icons/beverage/foodtaste/sodme".concat(taste, ".png"), alt: "".concat(taste, " av 12"), className: "small-icon" })));
        }
        return null;
    }
    function getBeverageInformation() {
        var beverageSection = products.map(function (product, index) {
            counter = 0;
            return React.createElement("div", { className: "compare-product-content".concat(index === 0 ? '-first' : ''), key: product.arident },
                React.createElement("section", { className: "ingredients" }, product.alcoholPercent && React.createElement(React.Fragment, null,
                    React.createElement("h2", { className: "hidden-xs" }, "Alkoholinformasjon"),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Alkoholprosent:"),
                        " ",
                        product.alcoholPercent,
                        "%"),
                    React.createElement("p", null,
                        React.createElement("strong", null, "\u00C5rgang:"),
                        " ",
                        product.beverage.vintage),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Passer til:")),
                    React.createElement(Grid_1.default, { container: true, spacing: 3, className: "beverage-taste-container", alignContent: "flex-start" },
                        getFoodPairings(product.beverage.foodPairing01),
                        getFoodPairings(product.beverage.foodPairing02),
                        getFoodPairings(product.beverage.foodPairing03)),
                    React.createElement(Grid_1.default, { container: true, spacing: 3, className: "beverage-foodpairing-container", alignContent: "flex-start" },
                        getTaste(product.beverage.freshness, "Friskhet"),
                        getTaste(product.beverage.fullness, "Fylde"),
                        getTaste(product.beverage.tannins, "Garvestoff"),
                        getTaste(product.beverage.sweetness, "Sødme"),
                        getTaste(product.beverage.bitterness, "Bitterhet")))));
        });
        return beverageSection;
    }
    function hasAlcoholInformation() {
        var hasAlcohol = false;
        products.forEach(function (p) {
            if (p.alcoholPercent > 0) {
                hasAlcohol = true;
            }
        });
        return hasAlcohol;
    }
    if (hasAlcoholInformation()) {
        return (React.createElement("div", { className: "row ingredient-section" },
            React.createElement("h2", { className: "visible-xs" }, "Alkoholinformasjon"),
            React.createElement("div", { className: "ingredient-container" }, getBeverageInformation())));
    }
    return null;
};
exports.Beverage = Beverage;
